import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TextSpinner from "../Spinner/TextSpinner";

const SelectDiretor = ({ formik, field, sqorgaologado, titulo }) => {
  const [diretor, setDiretor] = useState([]);

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (formik.values.setor && formik.values.setor !== 0) {
      request(apiRoutes.fiscalizacao.ordemservico.consultaDiretor, { sqOrgao: formik.values.setor });
    } else if (formik.values.sqSetor && formik.values.sqSetor !== 0) {
      request(apiRoutes.fiscalizacao.ordemservico.consultaDiretor, { sqOrgao: formik.values.sqSetor });
    } else if (sqorgaologado && sqorgaologado !== 0) {
      request(apiRoutes.fiscalizacao.ordemservico.consultaDiretor, { sqOrgao: sqorgaologado });
    }
  }, [request, formik.values.setor, sqorgaologado, formik.values.sqSetor]);

  useEffect(() => {
    if (data) {
      setDiretor(data.result);
    }
  }, [data]);

  return (
    <>
      {errors && (formik.values.setor || sqorgaologado || formik.values.setor) && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {errors.message ?? "Erro carregando lista de diretores"}
          </div>
        </>
      )}
      {isLoading ? (
        <TextSpinner text="Carregando diretor..." />
      ) : (
        <>
          <Form.Label>{titulo || "Diretor"}</Form.Label>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={formik.isSubmitting}
            value={formik.values[field]}
            onChange={formik.handleChange}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            <option key="0" value="">
              Selecione
            </option>
            {diretor.map((item) => (
              <option key={item.codigoDiretor} value={item.codigoDiretor}>
                {item.nomeDiretor}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectDiretor;
